/**
 * Generated Contract Version
 * Do not edit manually.
 */
export const CONTRACT_HASH = '368f678c9596c551';
export const BUILD_TIMESTAMP = 1768935110432;
//# sourceMappingURL=version.js.map